import { ArrowRight, BadgeDollarSign, CalendarDays, Check, Clock3, ShieldCheck, UsersRound, Video } from "lucide-react";
import Reveal from "@/components/Reveal";

const Hero = ({ onBook }) => {
  return (
    <section className="hero-section" aria-labelledby="hero-title">
      <div className="hero-layout">
        <Reveal className="hero-copy">
          <div className="eyebrow-pill">BUILT SPECIFICALLY FOR NEWCOMERS, TOURISTS &amp; STUDENTS IN CANADA</div>
          <h1 id="hero-title" className="hero-title">
            <span className="hero-line" style={{ "--line-delay": "80ms" }}>Speak Better Canadian.</span>
            <span className="hero-line" style={{ "--line-delay": "180ms" }}>Live, Work &amp; Belong</span>
            <span className="hero-line" style={{ "--line-delay": "280ms" }}>with Confidence.</span>
          </h1>
          <p className="hero-lead">Master authentic conversational idioms, practical workplace dialogue, and accent clarity with your certified Canadian ESL instructor.</p>
          <div className="hero-actions-row">
            <a href="#booking-section" className="button button-crimson hero-primary-button" onClick={onBook} aria-controls="booking-section" data-testid="hero-book-class-button">Explore Lessons &amp; Passes <ArrowRight size={17} /></a>
            <a href="#about" className="button button-outline hero-secondary-button" data-testid="hero-meet-instructor-button">Meet Our Instructor</a>
          </div>
          <div className="hero-enrollment-badge" data-testid="hero-lesson-count"><span>LIVE LESSONS SERVED</span><strong>429+</strong><small>Total Lessons Served to Date</small></div>
          <div className="hero-proof" aria-label="Lesson highlights">
            <div className="proof-item"><Check size={16} /><span>TEFL certified - TEFL.org</span></div>
            <div className="proof-item"><Video size={16} /><span>Live online</span></div>
            <div className="proof-item"><ShieldCheck size={16} /><span>Practical progress</span></div>
          </div>
        </Reveal>
        <Reveal className="hero-visual-reveal" delay={120}>
          <div className="hero-media-wrap" onMouseMove={(event) => {
            const rect = event.currentTarget.getBoundingClientRect();
            const x = ((event.clientX - rect.left) / rect.width - 0.5) * 8;
            const y = ((event.clientY - rect.top) / rect.height - 0.5) * 6;
            event.currentTarget.querySelector("img")?.style.setProperty("transform", `scale(1.04) translate(${x}px, ${y}px)`);
          }} onMouseLeave={(event) => event.currentTarget.querySelector("img")?.style.setProperty("transform", "scale(1.04) translate(0, 0)")}>
            <img src="/assets/virtual-learning-hero.jpg" alt="Representative online English lesson view with a small virtual group" className="hero-media-image" />
            <div className="session-visual-placeholder" data-testid="session-visual-placeholder"><strong>Representative lesson view</strong><span>Real student-consented session capture pending.</span></div>
            <div className="hero-media-caption"><CalendarDays size={15} /> Live online practice for real Canadian conversations</div>
          </div>
          <div className="platform-highlights-card" aria-label="Platform highlights preview" data-testid="platform-highlights-card">
            <div className="platform-highlights-head"><span>PLATFORM HIGHLIGHTS</span><span>LIVE LEARNING · 2026</span></div>
            <div className="platform-highlights-grid">
              <div className="platform-highlight"><Video size={17} /><span><strong>Live Google Meet</strong><small>Practice in real time</small></span></div>
              <div className="platform-highlight"><UsersRound size={17} /><span><strong>Small Groups</strong><small>Max 6 Learners per Session</small></span></div>
              <div className="platform-highlight"><BadgeDollarSign size={17} /><span><strong>$20 Reward</strong><small>For attending class</small></span></div>
            </div>
          </div>
          <div className="hero-time-note"><Clock3 size={15} /> Sessions are hosted online in Canadian time zones</div>
        </Reveal>
      </div>
    </section>
  );
};

export default Hero;
